import Container from "@mui/material/Container";
import { Button, Stack, TextField, Typography } from "@mui/material";
import Paper from "@mui/material/Paper";
import { addDoc, collection } from "firebase/firestore";
import { useState } from "react";
import firebaseConfig from "../firebase";
import { useNavigate } from "react-router-dom";
import { getFirestore } from 'firebase/firestore';
function WoodCreate() {
  const db = getFirestore(firebaseConfig)
  const navigate = useNavigate()
  const [woodImage, setWoodImage] = useState('');
  const [woodName, setWoodName] = useState("");
  const [woodSName, setWoodSName] = useState("");
  const [woodTName, setWoodTName] = useState("");
  const [woodLocate, setWoodLocate] = useState("");
  const [woodDesc, setWoodDesc] = useState("");
  const woodCollectionRef = collection(db, "Wood");

  const uploadImage = async (e) => {
    const file = e.target.files[0];
    const base64 = await convertBase64(file);
    setWoodImage(base64);
  };

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const createWood = async () => {
    await addDoc(woodCollectionRef, {
      woodName: woodName,
      woodSName: woodSName,
      woodTName: woodTName,
      woodLocate: woodLocate,
      woodDesc: woodDesc,
      woodImage: woodImage,
    });
    alert("บันทึกเรียบร้อย");
    navigate('/wood');
  };
  return (
    <Container class={Paper}>
      <Stack spacing={1.5}>
        <Typography
          variant="h1"
          sx={{
            fontWeight: "bold",
            fontSize: "2.25vw",
            marginTop: "20px",
            fontFamily: "Prompt",
          }}
        >
          เพิ่มชนิดไม้
        </Typography>
        <input type="file" 
        onChange={(e) => {
          uploadImage(e);
        }}/>
        <img src={woodImage} width="200px" />
        <TextField
          inputProps={{ style: { fontFamily: "Prompt" } }}
          InputLabelProps={{ style: { fontFamily: "Prompt" } }}
          variant="standard"
          label="ชื่อไม้*"
          onChange={(event) => {
            setWoodName(event.target.value);
          }}
        />
        <TextField
          inputProps={{ style: { fontFamily: "Prompt" } }}
          InputLabelProps={{ style: { fontFamily: "Prompt" } }}
          variant="standard"
          label="ชื่อวิทยาศาสตร์*"
          onChange={(event) => {
            setWoodSName(event.target.value);
          }}
        />
        <TextField
          inputProps={{ style: { fontFamily: "Prompt" } }}
          InputLabelProps={{ style: { fontFamily: "Prompt" } }}
          variant="standard"
          label="ชื่อทางการค้า*"
          onChange={(event) => {
            setWoodTName(event.target.value);
          }}
        />
        <TextField
          inputProps={{ style: { fontFamily: "Prompt" } }}
          InputLabelProps={{ style: { fontFamily: "Prompt" } }}
          variant="standard"
          label="สถานที่*"
          onChange={(event) => {
            setWoodLocate(event.target.value);
          }}
        />
        <TextField
          inputProps={{ style: { fontFamily: "Prompt" } }}
          InputLabelProps={{ style: { fontFamily: "Prompt" } }}
          variant="standard"
          label="รายละเอียด*"
          multiline
          rows={4}
          onChange={(event) => {
            setWoodDesc(event.target.value);
          }}
        />
        <Stack direction="row" justifyContent="flex-end" spacing={3}>
        <Button  sx={{ fontFamily:'Prompt'}} onClick={() => navigate('/wood')} variant="text" color="error">ยกเลิก</Button>
          <Button sx={{ fontFamily:'Prompt'}} onClick={createWood} variant="outlined" color="success">บันทึก</Button>
        </Stack>
      </Stack>
    </Container>
  );
}

export default WoodCreate;
